import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '影视分类', to: '/category' },
  { label: '汉字解析专题', to: '/special/hanzi-explanation' },
  { label: '剧情介绍专题', to: '/special/plot-introduction' },
  { label: '关于我们', to: '/about' },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-9 h-9 rounded-md bg-accent-500 text-secondary-950 flex items-center justify-center font-heading text-lg font-bold">
              邻
            </span>
            <span className="font-heading font-bold text-lg text-background-50">隔壁女孩中汉字</span>
          </div>
          <p className="text-sm font-label leading-relaxed text-background-200/90 max-w-sm">
            聚焦影视作品中的汉字内容解析与剧情介绍，从一笔一画读懂作品背后的文化内涵。
          </p>
        </div>

        <div>
          <h3 className="font-heading font-semibold text-background-50 mb-3">快速导航</h3>
          <ul className="space-y-2">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm font-label text-background-200/90 hover:text-accent-400 transition-colors"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading font-semibold text-background-50 mb-3">联系我们</h3>
          <ul className="space-y-2 text-sm font-label text-background-200/90">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
              hello@gebihanzi.example.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-wechat-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
              公众号：隔壁女孩中汉字
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
              线上内容平台 · 面向全网站友
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-700">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-label text-background-300/80">
            © 2026 隔壁女孩中汉字 · 本站内容为影视文化解析演示，仅供学习交流。
          </p>
          <p className="text-xs font-label text-background-300/80">
            剧中人物与作品均为虚构演示内容，如涉版权请联系删除。
          </p>
        </div>
      </div>
    </footer>
  );
}